import { cn } from '@/lib/utils';
import {
  BillRowAction,
  BillRowVm,
} from '@/features/dashboard/bookingChanges/types/BillViewModel.ts';
import { getBillRowActionLabel } from '@/features/dashboard/bookingChanges/types/BillViewModel.utils.ts';
import { actionButtonClass, cellClass } from './billRowStyles';

interface ActionCellProps {
  row: BillRowVm;
  isEditing: boolean;
  onAction?: (row: BillRowVm) => void;
}

/** Kolumna 4 — przycisk akcji wiersza. */
const ActionCell = ({ row, isEditing, onAction }: ActionCellProps) => {
  const action =
    row.action ?? (row.changed ? BillRowAction.EDIT : BillRowAction.CHANGE);

  return (
    <div
      className={cn(
        cellClass,
        '@max-[640px]:col-start-2 @max-[640px]:row-start-2 @max-[640px]:pt-1 flex justify-end',
      )}
    >
      <button
        type="button"
        onClick={() => onAction?.(row)}
        className={cn(
          actionButtonClass,
          // `visibility`, nie `display` — kolumna trzyma szerokość, więc wiersze
          // nie skaczą przy zmianie trybu.
          !isEditing && !row.locked && 'invisible',
        )}
      >
        {getBillRowActionLabel(action)}
      </button>
    </div>
  );
};

export default ActionCell;
